import React from 'react'
import { type ViewStyle } from 'react-native'
import { MapTag } from './MapTag'

export function NewMapTag(props: { testID?: string; style?: ViewStyle }) {
  return <MapTag variant="new" {...props} />
}
